import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Checkbox from "@material-ui/core/Checkbox";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import Button from "@material-ui/core/Button";
import { instance } from "Actions/AxiosInstance";
import { ErrorMessages } from "../../../../../Constants";
import {
  convertDateForBackend,
  getEJ2CalenderDateFormat,
} from "../../../../../Utils";
import { selectinputconverter } from "../../../../../Component/DynamicForm/Fields/Select";
import DynamicForm from "../../../../../Component/DynamicForm";
import { multiselectinputconverter } from "../../../../../Component/DynamicForm/Fields/MultiSelect";
import { DatePickerComponent } from "../../../../../Component/Custom";
import {
  setSaveProgress,
  removeSaveProgress,
} from "../../../../../Actions/SaveProgressAction";
import CustomLoader from "Component/CustomLoader";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

const styles = () => ({
  TableRow: {
    borderRadius: 4,
  },
  customWidth: {
    maxWidth: 300,
    height: "auto",
    maxHeight: "200px !important",
  },
});

class Openform extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedopenreviewemps: [],
      opendate: null,
      closedate: null,
      manualreviewformid: null,
      selectAllEmp: false,
    };

    this.handleChangeOpenReview = this.handleChangeOpenReview.bind(this);
    this.saveOpenForm = this.saveOpenForm.bind(this);
  }

  componentDidMount() {}

  selectAllEmpOnChange() {
    this.setState({ selectAllEmp: !this.state.selectAllEmp }, () => {
      this.handleChangeOpenReview([0], "selectedopenreviewemps");
    });
  }

  handleChangeOpenReview(value, key) {
    this.setState({
      [key]: key == "opendate" || key == "closedate" ? value.value : value,
    });
  }

  saveOpenForm() {
    const { manualreviewformid, selectedopenreviewemps, opendate, closedate } =
      this.state;
    if (
      !manualreviewformid ||
      !opendate ||
      selectedopenreviewemps.length == 0
    ) {
      this.props.enqueueSnackbar(ErrorMessages.E0020, { variant: "error" });
    } else if (
      opendate &&
      moment(opendate).format("YYYY-MM-DD") <
        moment(new Date()).format("YYYY-MM-DD") &&
      !closedate
    ) {
      this.props.enqueueSnackbar(ErrorMessages.E0020, { variant: "error" });
    } else if (this.state.selectAllEmp) {
      this.bulkOpenFormConfirmation();
    } else {
      const data = {
        reviewformid: manualreviewformid,
        formfor: {
          fortypeid: 6,
          forids: selectedopenreviewemps.join(","),
        },
        opendate: convertDateForBackend(opendate),
        closedate: convertDateForBackend(closedate),
      };
      const { issaveinprogress } = this.props.SaveInProgressReducer;
      if (!issaveinprogress) {
        this.props.setSaveProgress(true);
        this.setState({ isSaveLoading: true }, () => {
          instance
            .post("perform/openreviewformmanually", data)
            .then(() => {
              this.props.enqueueSnackbar("Saved successfully", {
                variant: "success",
              });
              this.props.removeSaveProgress();
              this.props.clearOpenForm();
              this.setState({ isSaveLoading: false });
            })
            .catch((error) => {
              this.props.removeSaveProgress();
              this.props.enqueueSnackbar(
                error && error.response
                  ? error.response.data.error.message
                  : error.message,
                { variant: "error" },
              );
              this.setState({ isSaveLoading: false });
            });
        });
      }
    }
  }

  bulkOpenFormConfirmation() {
    this.props.enqueueSnackbar(
      `You are manually opening a review form for ${this.props.allemps.length} employees. Please confirm this action.`,
      {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() =>
              this.setState({}, () => {
                const {
                  manualreviewformid,
                  selectedopenreviewemps,
                  opendate,
                  closedate,
                } = this.state;
                const data = {
                  reviewformid: manualreviewformid,
                  formfor: {
                    fortypeid: this.state.selectAllEmp ? 1 : 6,
                    forids: selectedopenreviewemps.join(","),
                  },
                  opendate: convertDateForBackend(opendate),
                  closedate: convertDateForBackend(closedate),
                };
                const { issaveinprogress } = this.props.SaveInProgressReducer;
                if (!issaveinprogress) {
                  this.props.setSaveProgress(true);
                  this.setState({ isSaveLoading: true }, () => {
                    instance
                      .post("perform/openreviewformmanually", data)
                      .then(() => {
                        this.props.enqueueSnackbar("Saved successfully", {
                          variant: "success",
                        });
                        this.props.removeSaveProgress();
                        this.props.clearOpenForm();
                        this.setState({ isSaveLoading: false });
                      })
                      .catch((error) => {
                        this.props.enqueueSnackbar(
                          error.response
                            ? error.response.data.error.message
                            : error.message,
                          { variant: "error" },
                        );
                        this.props.removeSaveProgress();
                        this.setState({ isSaveLoading: false });
                      });
                  });
                }
                this.props.closeSnackbar();
              })
            }
          >
            Confirm
          </Button>,
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => this.props.closeSnackbar()}
          >
            Cancel
          </Button>,
        ],
      },
    );
  }

  render() {
    const { allemps, masterprofileid, openForms, empList1 } = this.props;
    const { manualreviewformid, selectedopenreviewemps } = this.state;
    return (
      <div
        className="thin-scroll"
        style={{ height: "96vh", overflowY: "auto", paddingRight: 15 }}
        // onScroll={this.handleScroll1}
      >
        <div className="margin-bottom-16">
          <Grid container className="margin-top-8">
            <Grid item xs={12} md={12} sm={12}>
              <p className="normal-dark-secondary margin-bottom-8">
                Select a manual review form
              </p>
              <div>
                <DynamicForm
                  fields={selectinputconverter({
                    value: manualreviewformid || null,
                    placeholder: "Select review",
                    label: null,
                    options: openForms || [],
                  })}
                  onChange={(id) => {
                    this.handleChangeOpenReview(id, "manualreviewformid");
                  }}
                />
              </div>
              <p className="normal-dark-secondary margin-bottom-8">
                Select employee(s) under review
              </p>
              <div>
                <DynamicForm
                  fields={multiselectinputconverter({
                    value: this.state.selectAllEmp
                      ? [0]
                      : selectedopenreviewemps || [],
                    placeholder: "Select employees",
                    label: null,
                    // options:
                    //   masterprofileid != 9
                    //     ? this.props.empList1
                    //     : allemps || [],
                    options: this.state.selectAllEmp
                      ? [{ displayname: "All", displayvalue: 0 }]
                      : allemps || [],
                    idonly: true,
                    disabled: this.state.selectAllEmp,
                  })}
                  onChange={(id) => {
                    this.handleChangeOpenReview(id, "selectedopenreviewemps");
                  }}
                />
                <Checkbox
                  checked={this.state.selectAllEmp}
                  onChange={this.selectAllEmpOnChange.bind(this)}
                  value={this.state.selectAllEmp}
                  color="primary"
                  className="custom-checkbox floatleft"
                />
                <span className="normal-dark-secondary">
                  Select All Employees
                </span>
              </div>
              <p className="normal-dark-secondary margin-top-16 margin-bottom-8">
                Select review open date
              </p>
              <DatePickerComponent
                format={getEJ2CalenderDateFormat()}
                value={this.state.opendate}
                allowEdit={false}
                change={(e) => this.handleChangeOpenReview(e, "opendate")}
                width={"240px"}
                min={"1970-01-01"}
                max={new Date()}
              />

              <p className="normal-dark-secondary margin-bottom-8 margin-top-16">
                Select review end date
              </p>
              <DatePickerComponent
                id="startDate"
                allowEdit={false}
                min={
                  moment(this.state.opendate).format("YYYY-MM-DD") >=
                  moment(new Date()).format("YYYY-MM-DD")
                    ? this.state.opendate
                    : new Date()
                }
                value={this.state.closedate}
                format={getEJ2CalenderDateFormat()}
                disabled={this.state.opendate ? false : true}
                // min={this.state.minApplyDate}
                change={(e) => this.handleChangeOpenReview(e, "closedate")}
                // className="selectsearch input-area-section"
                width={"240px"}
              />
              <div className="margin-top-16">
                <Button
                  variant="contained"
                  className={
                    this.props.SaveInProgressReducer.issaveinprogress
                      ? "btn btn-primary-md-grey"
                      : "btn btn-primary-md-blue"
                  }
                  color="primary"
                  disabled={this.props.SaveInProgressReducer.issaveinprogress}
                  onClick={this.saveOpenForm}
                >
                  Save
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
        <Dialog
          fullWidth={true}
          maxWidth="lg"
          open={this.state.isSaveLoading}
          // onClose={() => this.setState({ openDialog: false, empform1: null })}
          aria-labelledby="max-width-dialog-title"
          classes={{
            scrollPaper: "no-shadow bg-transparent",
            paper: "no-shadow bg-transparent",
          }}
        >
          <DialogContent>
            <CustomLoader />
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  SaveInProgressReducer: state.SaveInProgressReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setSaveProgress,
      removeSaveProgress,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(Openform)));
